import { render, staticRenderFns } from "./ChatMessenger.vue?vue&type=template&id=67984dba&scoped=true&"
import script from "./ChatMessenger.vue?vue&type=script&lang=js&"
export * from "./ChatMessenger.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessenger.vue?vue&type=style&index=0&id=67984dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67984dba",
  null
  
)

export default component.exports